import React, { Component } from "react";
import FirmsForm from "../FirmsForm/FirmsForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : FirmsPage
Description : Componente que contienen el formulario de la pantalla Firms
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente FirmsForm
================================================================================ */
class FirmsPage extends Component{
    render(){
        return(
            <div>                    
                <FirmsForm/>
            </div>
        )   
    }
}

export default FirmsPage;